import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
  selector: 'lib-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.scss'],
})
export class DialogConfirmComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();

  companyId: string;
  activeAreaIds: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogConfirmComponentData
  ) {}

  ngOnInit() {}

  toggleActiveAreas(areaId: string) {
    const idIndex = this.activeAreaIds.indexOf(areaId);
    const alreadyAdded = idIndex > -1;
    alreadyAdded ? this.activeAreaIds.splice(idIndex, 1) : this.activeAreaIds.push(areaId);
  }

  closeDialog(value?: boolean) {
    this.dialogRef.close(value);
  }

  submit() {
    this.dialogRef.close({ accepted: true });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

export interface DialogConfirmComponentData {
  subHeader?: string;
  description: string;
  descriptionItems?: string[];
  mainHeader: string;
  cancelBtnText?: string;
  forcedAgree?: boolean;
  confirmBtnText?: string;
}
